import React from "react";
import { Outlet } from "react-router-dom"; // ← Renders child routes

const Layout: React.FC = () => {
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column", marginTop: "25px" }}
    >
      <main style={{ flex: 1 }}>
        <Outlet /> {/* ← Renders Home/StorePage/etc. */}
      </main>
    </div>
  );
};

export default Layout;
